export default __webpack_public_path__ + "static/media/master_card_image.0ebd6948.svg";